import { type Options, useCrossFlow } from '@atlassiansox/cross-flow-support';
import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';
import { useMessageEvent } from '@post-office/message-lifecycle';
import { useCallback } from 'react';

export const useCrossflowMessageClicked = (
	crossflowOptions: Options,
	interactionIdentifier: string,
): {
	handleClick: () => void;
} => {
	const crossflow = useCrossFlow();
	const { messageClicked } = useMessageEvent();
	const { onCtaActioned } = usePostOfficeUserInteractions();

	const handleClick = useCallback((): void => {
		messageClicked().catch(() => {});
		void onCtaActioned({
			interactionIdentifier,
			additionalMetadata: {},
		});
		if (crossflow.isEnabled) {
			crossflow.api.open(crossflowOptions).catch(() => {});
		}
	}, [crossflow, crossflowOptions, interactionIdentifier, messageClicked, onCtaActioned]);

	return { handleClick };
};
